export default __webpack_public_path__ + "static/media/calendar.e6059edb.svg";